let sideBarOpenButton = document.querySelector('[data-toggle-ingeridants]');
let sideBarCloseButton = document.querySelector('[data-ingeridant-close]');
const details = document.querySelectorAll('details');

sideBarOpenButton.addEventListener('click', function(e){
  e.preventDefault();
  document.body.classList.add('show__ingeridants');
});

sideBarCloseButton.addEventListener('click', function(e){
  e.preventDefault();
  document.body.classList.remove('show__ingeridants');
});

details.forEach(detail => {
  detail.addEventListener('click', () => {
    details.forEach(d => {
      if (d !== detail) {
        d.removeAttribute('open');
      }
    });
  });
});